import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { createCheckoutSession } from '../../services/stripeService';

const PricingCard = ({ title, price, features, buttonText, priceId }) => {
  // Recibimos `priceId` en props

  const handleSelectPlan = async (priceId) => {
    const { redirectUrl } = await createCheckoutSession(priceId);
    if (redirectUrl) {
      console.log("URL de Checkout:", redirectUrl);
      window.location.href = redirectUrl;
    } else {
      alert('Hubo un error al procesar el pago. Revisa la consola para más detalles.');
    }
  };
  console.log("priceId: ", priceId)

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h4" component="div" gutterBottom>
          ${price}
        </Typography>
        <Box sx={{ my: 2 }}>
          {features.map((feature, index) => (
            <Typography key={index} variant="body1" sx={{ my: 1 }}>
              {feature}
            </Typography>
          ))}
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => handleSelectPlan(priceId)} // <-- IMPORTANTE
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
};

export default PricingCard;
